import { STATE } from "./names";

export default () => {
    return {
        [STATE.IS_UPGRADING_TO_AFFILIATE]: false,
    };
};